import allconstants from "../../constants";

export const HandleCountriesInput = (e) => {
  const { value, name } = e.target ? e.target : e;
  return { type: "COUNTRIES_INPUT_CHANGE", changedField: { [name]: value } };
};
export const IsLoading = (payload) => {
  return { type: "LOADING_COUNTRIES", payload };
};
export const clearCountriesForm = (e) => {
  e.preventDefault();
  return { type: "CLEAR_COUNTRIES_FORM" };
};

export const processingCountriesRequest = (value) => {
  return { type: "COUNTRIES_REQUEST_PROCESSING", value };
};

export const CountriesFetchSuccess = (payload, msg) => {
  return { type: "FETCH_COUNTRIES_SUCCESS", payload };
};
export const CountriesAddSuccess = (new_record, update = false) => {
  if (update) {
  } else {
  }
  return { type: "ADD_COUNTRIES_SUCCESS", new_record };
};
export const CountriesDeleteSuccess = (msg, record_id) => {
  return { type: "DELETE_COUNTRIES_SUCCESS", record_id };
};
export const CountriesReqError = (msg) => {
  return { type: "COUNTRIES_ERROR" };
};

export const editCountries = (obj) => {
  return { type: "EDIT_COUNTRIES", current_countries_obj: obj };
};
export const HandleCountriesSubmit =
  (form_data, toggle, setErrors, setSubmitting) => (dispatch) => {
    dispatch(processingCountriesRequest(true));
    const url = form_data.id
      ? allconstants.apiurl + "country/" + form_data.id
      : allconstants.apiurl + "country";
    const req_type = form_data.id
      ? allconstants.axios.put
      : allconstants.axios.post;
    req_type(url, form_data, { headers: allconstants.headers })
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          setSubmitting(false);
          if (form_data.id) {
            dispatch(CountriesAddSuccess(response.data, true));
            dispatch(processingCountriesRequest(false));
          } else {
            dispatch(CountriesAddSuccess(response.data));
            dispatch(processingCountriesRequest(false));
          }
          toggle();
        }
      })
      .catch((error) => {
        dispatch(processingCountriesRequest(false));
        setSubmitting(false);
        if (error.response) {
          setErrors(error.response.data.errors);
          console.log(error.response);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Bad/No internet connection");
        }
      });

    return null;
  };
export const HandleCountriesDelete = (record_id, toggle) => (dispatch) => {
  const url = allconstants.apiurl + "country/" + record_id;
  dispatch(processingCountriesRequest(true));
  allconstants.axios
    .delete(url, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    })
    .then((response) => {
      if (response.status === 201 || response.status === 200) {
        dispatch(CountriesDeleteSuccess(response.message, record_id));
      } else if (response.status === 404) {
        dispatch(CountriesReqError("Record dosent exist "));
      }
      dispatch(processingCountriesRequest(false));
      toggle();
    })
    .catch((error) => {
      if (error.response) {
        dispatch(processingCountriesRequest(false));
        console.log(error.response);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log("Bad/No internet connection");
      }
    });
};
export const HandleCountriesFetch = () => (dispatch) => {
  const url = allconstants.apiurl + "country";
  allconstants.axios
    .get(url, { headers: allconstants.headers })
    .then((response) => {
      if (response.status === 200) {
        dispatch(CountriesFetchSuccess(response.data));
        dispatch(IsLoading(false));
      }
    })
    .catch((error) => console.error(error));
  return null;
};
